import React from 'react';
import { DatabaseQuery } from '../../../../../gen-src/queries';
import {
  SelectionProviderChildProps,
  VerticalFlexContainer
} from '../../../data-catalog-shared';
import { PaneWithTitle } from '../placePage/PaneWithTitle';
import { TablesGridSortProvider } from '../sorting/sortProviders/TablesGridSortProvider';
import { DatabaseDetails } from './DatabaseDetails';
import { DatabaseTablesQueryGrid } from './DatabaseTablesQueryGrid';

type Database = Unpacked<DatabaseQuery['databases']>

export interface DatabaseTablesPaneProps extends SelectionProviderChildProps {
  readonly title: string;
  readonly database: Database;
  readonly databaseId: string;
  readonly rowCount: number | null;
}

export function DatabaseTablesPane(props: DatabaseTablesPaneProps): JSX.Element {
  return (
    <VerticalFlexContainer fillFlexParent={true}>
      <DatabaseDetails database={props.database} />
      <PaneWithTitle title={props.title}>
        <TablesGridSortProvider>
          {({ orderBy, updateSortOrder }) =>
            <DatabaseTablesQueryGrid
              databaseId={props.databaseId}
              selectedKeys={props.selectedKeys}
              updateSelectionForKey={props.updateSelectionForKey}
              rowCount={props.rowCount}
              orderBy={orderBy}
              updateSortOrder={updateSortOrder}
            />
          }
        </TablesGridSortProvider>
      </PaneWithTitle>
    </VerticalFlexContainer>
  );
}
